import React from 'react';
import { HeroVariant1 } from '../components/HeroVariant1';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage1() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1441">
      <Navigation data-id="element-1442" />
      <main data-id="element-1443">
        <HeroVariant1 data-id="element-1444" />
        <WhyUs data-id="element-1445" />
        <Services data-id="element-1446" />
        <FAQ data-id="element-1447" />
        <Testimonials data-id="element-1448" />
        <Consultation data-id="element-1449" />
      </main>
      <Footer data-id="element-1450" />
      <CookieBanner data-id="element-1451" />
      <FloatingContact data-id="element-1452" />
    </div>;
}